import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Pagination,
  Tooltip,
  OverlayTrigger,
  Grid,
  Col,
  Row,
  FormControl,
  FormGroup,
  ControlLabel,
} from "react-bootstrap";
import { CreateBannerNoticeData } from "api/bannerNotice/bannerNotice";
import NotificationSystem from "react-notification-system";
import Datetime from "react-datetime";
import Select from "react-select";
import moment from "moment";
import Axios from "axios";

const CreateBannerNotice = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const _notificationSystem = React.createRef();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [titleError, setTitleError] = useState(null);
  const [dateError, setDateError] = useState(null);

  useEffect(() => {}, []);
  const handleStartDate = (value) => {
    setStartDate(value);
  };
  const handleEndDate = (value) => {
    setEndDate(value);

    if (startDate && moment(value).isAfter(moment(startDate))) {
      setDateError(null);
    } else if (startDate && moment(value).isSameOrBefore(moment(startDate))) {
      setDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          End date must be after Start date
        </small>
      );
    }
  };

  const validateRequestDate = (current) => {
    return current.isSameOrAfter(moment(), "day");
  };

  const onSubmit = async () => {
    let error = false;
    if (!title) {
      error = true;
      setTitleError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Title is Required
        </small>
      );
    } else {
      setTitleError(null);
    }
    if (!startDate || !endDate) {
      error = true;
      setDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Both Start and End date are required
        </small>
      );
    } else if (!moment(endDate).isAfter(moment(startDate))) {
      error = true;
      setDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          End date must be after Start date
        </small>
      );
    } else {
      setDateError(null);
    }
    if (error) return;

    const data = {
      title: title,
      description: description || "",
      icon_path: imageUrl || null,
      start_time: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      end_time: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
    };

    try {
      const res = await CreateBannerNoticeData(data, obj);

      if (res.status === 201) {
        _notificationSystem.current.addNotification({
          message: "Banner Notice submitted successfully!",
          level: "success",
        });
        setTimeout(() => {
          props.history.push("/admin/banner-notice-list");
        }, 2000);
      } else {
        _notificationSystem.current.addNotification({
          message: "Failed to submit Banner Notice.",
          level: "error",
        });
      }
    } catch (error) {
      console.error("Error creating banner notice:", error);
      _notificationSystem.current.addNotification({
        message: "An error occurred while submitting Banner Notice.",
        level: "error",
      });
    }
  };

  const handleEnterDescription = (event) => {
    const enterValue = event.target.value;
    setDescription(enterValue);
  };
  const handleImageUrl = (event) => {
    const imageUrl = event.target.value;
    setImageUrl(imageUrl);
  };
  const handleTitleValue = (event) => {
    const enterTitle = event.target.value;
    setTitle(enterTitle);
    if (enterTitle) {
      setTitleError(null);
    }
  };

  return (
    <div className="main-content">
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        <Col md={8}>
          <Card
            content={
              <div
                style={{
                  marginBottom: "40px",
                  padding: "0 20px",
                }}
              >
                <Col>
                  <Row>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>Start Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            inputProps={{
                              placeholder: "Start Time",
                            }}
                            isValidDate={validateRequestDate}
                            closeOnSelect={true}
                            value={startDate}
                            onChange={handleStartDate}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>End Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            inputProps={{
                              placeholder: "End Time",
                            }}
                            isValidDate={validateRequestDate}
                            closeOnSelect={true}
                            value={endDate}
                            onChange={handleEndDate}
                          />
                        </div>
                        {dateError}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>Title</ControlLabel>
                          <FormControl
                            type="text"
                            name="title"
                            placeholder="Enter Title"
                            onChange={handleTitleValue}
                            value={title}
                          />
                        </div>
                        {titleError}
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>Description</ControlLabel>
                          <textarea
                            maxlength="220"
                            className="form-control"
                            rows="4"
                            cols="5"
                            placeholder="Enter Reference"
                            onChange={handleEnterDescription}
                            value={description}
                          ></textarea>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>Lottie Image URL</ControlLabel>
                          <textarea
                            className="form-control"
                            rows="7"
                            cols="5"
                            placeholder="Paste Or Enter Lottie URL"
                            onChange={handleImageUrl}
                            value={imageUrl}
                          ></textarea>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                <Button
                  class="btn-color"
                  onClick={() => onSubmit()}
                  style={{ marginTop: "20px" }}
                >
                  Submit
                </Button>
              </div>
            }
          ></Card>
        </Col>
      </Grid>
    </div>
  );
};
export default CreateBannerNotice;
